// @ts-strict-ignore
import { useState } from 'react';
import TextInput from '@carvana/ds-text-input';
import LinkButton from '@carvana/ds-link-button';
import { useTestFunc } from '@carvana/test-attributes';
import useModal from '@carvana/ds-modal';


import WhereIsMyVinContent from '../WhereIsMyVin';
import { Row, VinInputWrapper } from './VinEntry.styles';

type UpdateVin = (event: React.ChangeEvent<HTMLInputElement>) => void;

type VinEntryProps = {
  error?: string;
  updateVin: UpdateVin;
  touched: boolean;
  vin: string;
};

const VinEntry = ({ error = null, touched, updateVin, vin }: VinEntryProps) => {
  const getTestAttributes = useTestFunc();
  const [isPristine, setIsPristine] = useState(true);
  const portalRoot = document.getElementById('modal-root') as Element;
  const { Modal, openModal, closeModal } = useModal({ rootNode: portalRoot });

  const setNotPristine = () => setIsPristine(false);

  const vinTouched = touched || !isPristine;
  const errorMessage = (vinTouched && error) || '';

  return (
    <Row>
      <VinInputWrapper>
        <TextInput
          {...getTestAttributes('Input')}
          hasError={!!errorMessage}
          id="vin"
          label="VIN"
          maxLength={17}
          onBlur={setNotPristine}
          onChange={updateVin}
          value={vin}
          error={errorMessage}
        />
      </VinInputWrapper>
      <LinkButton variant="default" size="sm" underline={false} onClick={openModal}>
        Where is my VIN?
      </LinkButton>
      <Modal divLine={false} desktopWidth="580px" mobileStyle="inset">
        <WhereIsMyVinContent closeModal={closeModal} />
      </Modal>
    </Row>
  );
};

export default VinEntry;
